import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const PreloadImages = () => {
  const location = useLocation();

  useEffect(() => {
    const imgs = document.querySelectorAll("img[src]");
    const head = document.head;

    imgs.forEach((img) => {
      const rect = img.getBoundingClientRect();
      const inViewport = rect.top >= 0 && rect.top < window.innerHeight;

      if (inViewport) {
        img.setAttribute("fetchpriority", "high");
      } else {
        img.setAttribute("loading", "lazy");
      }

      if (!head.querySelector(`link[rel="preload"][href="${img.src}"]`)) {
        const link = document.createElement("link");
        link.rel = "preload";
        link.as = "image";
        link.href = img.src;
        if (inViewport) {
          link.setAttribute("fetchpriority", "high");
        }
        head.appendChild(link);
      }
    });
  }, [location]);

  return null;
};

export default PreloadImages;
